module.exports = __webpack_public_path__ + "static/media/YDJSP.8fc1e6db.pdf";